import { LogLevel, LogType, LoggerInterface, LoggerOptions } from './loggerModels';
import redact from './redact';

export class InternalLogger implements LoggerInterface {
  constructor(
    private actualLogger: LoggerInterface,
    private loggerOptions: LoggerOptions = {},
  ) {}

  redact(info?: Record<string, any>): Record<string, any> | undefined {
    return info ? redact(info, this.loggerOptions.redaction) : info;
  }

  child(attributes: Object): LoggerInterface {
    return this.actualLogger.child(attributes, this.loggerOptions);
  }

  silly(message: string, attributes?: Object): void {
    this.emitLogMessage(LogLevel.silly, message, attributes);
  }

  trace(message: string, attributes?: Object): void {
    this.emitLogMessage(LogLevel.trace, message, attributes);
  }

  debug(message: string, attributes?: Object): void {
    this.emitLogMessage(LogLevel.debug, message, attributes);
  }

  info(message: string, attributes?: Object): void {
    this.emitLogMessage(LogLevel.info, message, attributes);
  }

  warn(message: string, attributes?: Object): void {
    this.emitLogMessage(LogLevel.warn, message, attributes);
  }

  error(message: string, attributes?: Object): void {
    this.emitLogMessage(LogLevel.error, message, attributes);
  }

  fatal(message: string, attributes?: Object): void {
    this.emitLogMessage(LogLevel.fatal, message, attributes);
  }

  log(message: string, attributes?: Object): void {
    this.emitLogMessage(LogLevel.log, message, attributes);
  }

  private emitLogMessage(logLevelId: LogLevel, message: string, attributes?: Object) {
    const logLevelType: LogType = LogLevel[logLevelId] as LogType;
    if (this.actualLogger && (this.loggerOptions.desiredLogLevel ?? 0) <= logLevelId) {
      this.actualLogger[logLevelType](message, this.redact(attributes));
    }
  }
}
